export interface AutocompleteSearchHit {
  query: string;
  type: string;
}

export class AutocompleteSearch {
  status?: string;
  hits?: Array<AutocompleteSearchHit>;
}
